<template>
    <v-content>
        <v-breadcrumbs :items="breadCrumbs" large></v-breadcrumbs>
        <v-row>
            <v-col
                    class="viewCard"
                    cols="auto"
            >


                <router-link to="/report">
                    <v-card
                            :elevation="10"
                            class="main-color text-center"
                            height="150"
                            width="300"
                    >
                        <v-list-item link>
                            <v-list-item-content>
                                <v-list-item-title
                                        class="white--text subtitle-1 mt-1 pa-4"
                                >
                                    <div>
                                        <span>Report Form</span>
                                    </div>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>
                </router-link>
            </v-col>
            <v-col
                    class="viewCard"
                    cols="auto"
            >
                <router-link to="/anuchcharuReport">
                    <v-card
                            :elevation="10"
                             class="main-color text-center"
                            height="150"
                            width="300"
                    >
                        <v-list-item link>
                            <v-list-item-content>
                                <v-list-item-title
                                        class="white--text subtitle-1 mt-1 pa-4"
                                >
                                    <div>
                                        <span>AnuSucharu Report</span>
                                    </div>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>
                </router-link>
            </v-col>
            <v-col
                    class="viewCard"
                    cols="auto"
            >
                <router-link to="/samikshyaReport">
                    <v-card
                            :elevation="10"
                            class="main-color text-center"
                            height="150"
                            width="300"
                    >
                        <v-list-item link>
                            <v-list-item-content>
                                <v-list-item-title
                                       class="white--text subtitle-1 mt-1 pa-4"
                                >
                                    <div>
                                        <span>Samikshya Report </span>
                                    </div>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>
                </router-link>
            </v-col>
        </v-row>
    </v-content>
</template>

<script>
    import { mapGetters } from "vuex";

    export default {
        name: "CompanySettings",
        data() {
            return{
                breadCrumbs:[]
            }
        },
        computed: {
            ...mapGetters({
                userRole: 'getUserRole',
                usersData: 'getUserData',
            }),
        },
        methods: {
            getBreadcrumb(){
                this.breadCrumbs = [
                    {
                        text: 'Dashboard',
                        disabled: false,
                        to: `${this.usersData.dashBoard}`,
                        exact: true

                    },
                    {
                        text: 'Report',
                        disabled: true,
                    },
                ]
            }
        },
        mounted() {
            this.getBreadcrumb()
        },
        components: {
       }
    }
</script>

<style lang="scss" scoped>
    .options {
        border: 2px solid white;
    }

</style>

<!--<template>-->
<!--    <v-content>-->
<!--        <div class="container">-->
<!--            <v-breadcrumbs :items="snackbar.breadcrumbItems" large></v-breadcrumbs>-->
<!--            <vue-good-table-->
<!--                    :columns="columns"-->
<!--                    :rows="rows"-->
<!--                    mode="remote"-->
<!--                    :totalRows="branchData.totalRecords"-->
<!--                    :pagination-options="{ enabled: true,mode: 'records' }"-->
<!--                    @on-page-change="onPageChange"-->
<!--                    @on-sort-change="onSortChange"-->
<!--                    @on-column-filter="onColumnFilter"-->
<!--                    @on-per-page-change="onPerPageChange"-->
<!--                    styleClass="vgt-table condensed"-->
<!--            >-->
<!--                <template slot="table-row" slot-scope="props">-->
<!--                <span v-if="props.column.field == 'establishedYear'">-->
<!--                  <span>{{props.row.establishedYear | moment("DD-MMM-YYYY, h:mm:ss a")}}</span>-->
<!--                </span>-->
<!--                </template>-->
<!--            </vue-good-table>-->
<!--            <v-dialog-->
<!--                    v-model="snackbar.formModal"-->
<!--                    fullscreen-->
<!--                    hide-overlay-->
<!--                    transition="dialog-bottom-transition"-->
<!--                    persistent-->
<!--            >-->
<!--                <v-card>-->
<!--                    <BranchForm @dialogueClose="dialogueClose"-->
<!--                                        @formResponse="formResponse"-->
<!--                                        v-if="snackbar.createFormComponent"-->
<!--                    ></BranchForm>-->
<!--                    <BranchEditForm @dialogueClose="dialogueClose"-->
<!--                                            @formResponse="formResponse"-->
<!--                                            v-if="snackbar.editFormComponent"-->
<!--                                            :editItemIndex="branchData.editItemIndex"-->
<!--                    ></BranchEditForm>-->
<!--                </v-card>-->
<!--            </v-dialog>-->
<!--            <v-snackbar-->
<!--                    v-model="snackbar.snackbar"-->
<!--                    :color="snackbar.color"-->
<!--                    :timeout="snackbar.timeout"-->
<!--                    top-->
<!--            >-->
<!--                {{ snackbar.text }}-->
<!--                <v-btn-->
<!--                        dark-->
<!--                        text-->
<!--                        @click="snackbar.snackbar = false"-->
<!--                >-->
<!--                    Close-->
<!--                </v-btn>-->
<!--            </v-snackbar>-->
<!--            <v-dialog v-model="snackbar.dialogDelete" max-width="500px">-->
<!--                <deleteListData :deleteFormData="branchData.deleteFormData"-->
<!--                                @formResponse="onResponseDelete"></deleteListData>-->
<!--            </v-dialog>-->
<!--        </div>-->
<!--    </v-content>-->
<!--</template>-->

<!--<script>-->
<!--    import axios from "axios";-->
<!--    import BranchForm from "./BranchForm";-->
<!--    import BranchEditForm from "./BranchEditForm";-->
<!--    import deleteListData from "@/components/deleteModal";-->
<!--    import {mapGetters} from "vuex";-->

<!--    export default {-->
<!--        name: "BranchList",-->
<!--        components: {-->
<!--            'BranchForm': BranchForm,-->
<!--            'BranchEditForm': BranchEditForm,-->
<!--            'deleteListData': deleteListData-->
<!--        },-->
<!--        computed: {-->
<!--            ...mapGetters({-->
<!--                userRole: 'getUserRole',-->
<!--                usersData: 'getUserData',-->
<!--            }),-->
<!--            branchPermission(){-->
<!--                return this.isSuperAdmin || this.isCompany || this.isDepartment-->
<!--            },-->
<!--            isSuperAdmin() {-->
<!--                return this.userRole === "SuperAdmin"-->
<!--            },-->
<!--            isCompany() {-->
<!--                return this.userRole === "Company"-->
<!--            },-->
<!--            isDepartment() {-->
<!--                return this.userRole === "Department"-->
<!--            },-->
<!--        },-->
<!--        data() {-->
<!--            return {-->
<!--                breadDetails:[],-->
<!--                columns: [-->
<!--                    {-->
<!--                        label: 'Name',-->
<!--                        field: 'name',-->
<!--                    },-->
<!--                    {-->
<!--                        label: 'Code',-->
<!--                        field: 'code',-->
<!--                    },-->
<!--                    {-->
<!--                        label: 'Address',-->
<!--                        field: 'address',-->
<!--                    },-->
<!--                    {-->
<!--                        label: 'Phone Number',-->
<!--                        field: 'phoneNumber',-->
<!--                    },-->
<!--                    {-->
<!--                        label: 'Email',-->
<!--                        field: 'email',-->
<!--                    },-->
<!--                    {-->
<!--                        label: 'Website',-->
<!--                        field: 'website',-->
<!--                    },-->
<!--                    {-->
<!--                        label: 'Established Year',-->
<!--                        field: 'establishedYear',-->
<!--                    }-->
<!--                ],-->
<!--                rows: [],-->
<!--                branchData: {-->
<!--                    totalRows: 0,-->
<!--                    editItemIndex: null,-->
<!--                    deleteFormData: {}-->
<!--                },-->
<!--                serverParams: {-->
<!--                    search: "",-->
<!--                    columnFilters: {},-->
<!--                    sort: [-->
<!--                        {-->
<!--                            field: "branchID",-->
<!--                            type: "desc"-->
<!--                        }-->
<!--                    ],-->
<!--                    page: 1,-->
<!--                    perPage: 10-->
<!--                },-->
<!--                snackbar: {-->
<!--                    color: '',-->
<!--                    snackbar: false,-->
<!--                    text: '',-->
<!--                    timeout: 6000,-->
<!--                    isLoading: false,-->
<!--                    formModal: false,-->
<!--                    createFormComponent: false,-->
<!--                    editFormComponent: false,-->
<!--                    dialogDelete: false,-->
<!--                    breadcrumbItems: [],-->
<!--                    dynamicComponent: {-->
<!--                        current: 'BranchForm'-->
<!--                    }-->
<!--                }-->
<!--            };-->
<!--        },-->
<!--        methods: {-->
<!--            updateParams(newProps) {-->
<!--                this.serverParams = Object.assign({}, this.serverParams, newProps);-->
<!--            },-->

<!--            onPageChange(params) {-->
<!--                this.updateParams({page: params.currentPage});-->
<!--                this.loadItems();-->
<!--            },-->

<!--            onPerPageChange(params) {-->
<!--                this.updateParams({perPage: params.currentPerPage});-->
<!--                this.loadItems();-->
<!--            },-->

<!--            onSortChange(params) {-->
<!--                this.updateParams({-->
<!--                    sort: [{-->
<!--                        type: params[0].type,-->
<!--                        field: params[0].field,-->
<!--                    }],-->
<!--                });-->
<!--                this.loadItems();-->
<!--            },-->

<!--            onColumnFilter(params) {-->
<!--                this.updateParams(params);-->
<!--                this.loadItems();-->
<!--            },-->
<!--            addModal() {-->
<!--                this.snackbar.formModal = true-->
<!--                this.snackbar.createFormComponent = true-->
<!--            },-->
<!--            editItem(item) {-->
<!--                this.snackbar.formModal = true-->
<!--                this.snackbar.editFormComponent = true-->
<!--                this.branchData.editItemIndex = item.branchID-->
<!--            },-->
<!--            deleteItem(item) {-->
<!--                this.snackbar.dialogDelete = true;-->
<!--                this.branchData.deleteFormData.url = "Branch/Delete/" + item.branchID;-->
<!--                this.loadItems();-->
<!--            },-->
<!--            onResponseDelete() {-->
<!--                this.snackbar.dialogDelete = false;-->
<!--                this.loadItems();-->
<!--            },-->
<!--            formResponse(responseObj) {-->
<!--                this.snackbar.color = responseObj.color ? responseObj.color : 'red'-->
<!--                this.snackbar.text = responseObj.message ? responseObj.message : 'Server Error'-->
<!--                this.snackbar.snackbar = true-->
<!--                this.loadItems();-->
<!--            },-->
<!--            dialogueClose() {-->
<!--                this.branchData.editItemIndex = null-->
<!--                this.snackbar.formModal = false-->
<!--                this.snackbar.createFormComponent = false-->
<!--                this.snackbar.editFormComponent = false-->
<!--                this.loadItems()-->
<!--            },-->
<!--            async loadItems() {-->
<!--                this.snackbar.isLoading = true;-->
<!--                let param = {-->
<!--                    PageSize: this.serverParams.perPage,-->
<!--                    PageNo: this.serverParams.page,-->
<!--                    OrderType: this.serverParams.sort[0].type,-->
<!--                    OrderBy: this.serverParams.sort[0].field,-->
<!--                    isActive : true,-->
<!--                    departmentID: parseInt(this.$route.params.id)-->
<!--                };-->
<!--                axios.post('Branch/BranchList', param).then(response=>{-->
<!--                    this.rows = response.data.list.data-->
<!--                    this.breadDetails = response.data.details-->
<!--                    this.branchData.totalRecords = response.data.list.totalCount-->
<!--                    this.snackbar.loading = false;-->
<!--                    this.breadCrumbsItem()-->
<!--                })-->
<!--            },-->
<!--            breadCrumbsItem(){-->
<!--                this.snackbar.breadcrumbItems =[-->
<!--                    {-->
<!--                        text: "Dashboard",-->
<!--                        disabled: false,-->
<!--                        to: this.usersData.dashBoard,-->
<!--                        exact: true-->
<!--                    },-->
<!--                    {-->
<!--                        text: "Company",-->
<!--                        disabled: false,-->
<!--                        to: "/CompanyList",-->
<!--                        exact: true-->
<!--                    },-->
<!--                    {-->
<!--                        text: this.breadDetails.companyName,-->
<!--                        disabled: false,-->
<!--                        to: `/department/${this.breadDetails.companyID}`,-->
<!--                        exact: true-->
<!--                    },{-->
<!--                        text: this.breadDetails.departmentName,-->
<!--                        disabled: true,-->
<!--                        to: "/company",-->
<!--                        exact: true-->
<!--                    },-->

<!--                ]-->
<!--            }-->
<!--        },-->
<!--        mounted() {-->
<!--            this.loadItems()-->
<!--        },-->

<!--    }-->
<!--</script>-->

<!--<style scoped>-->

<!--</style>-->
